import i18next from "i18next";
import { camelCase, upperFirst } from "lodash-es";
import * as Sentry from "@sentry/vue";

/**
 * @desc Return apollo reference by reading object's id value. Otherwise return null
 * @param object apollo helpers
 * @param options { typename?: string; customFieldName?: string }
 * @return null or reference to apollo cache
 */
export function fetchField(methods, options = {}) {
  const id = methods.readField(
    options.customFieldName || methods.fieldName + "Id"
  );
  if (!id) {
    /*
    if(id === undefined) {
    console.warn(
      `Missing id fieldName ` +
        (options.customFieldName || methods.fieldName + "Id") +
        ` for ${methods.fieldName}`
    );}*/
    return null;
  }
  const typename = options.typename || upperFirst(camelCase(methods.fieldName));
  const cacheId = `${typename}:${id}`;

  if (methods.cache.data.data[cacheId]) {
    return methods.toReference({
      __typename: typename,
      id
    });
  }

  if (process.env.NODE_ENV === "development") {
    console.error(`${cacheId} is missing from cache! `);
  }

  Sentry.withScope(function (scope) {
    scope.setLevel("fatal");
    scope.setContext("Apollo cache", { fieldName: methods.fieldName });
    Sentry.captureMessage(`${cacheId} is missing from cache!`);
  });
  return null;
}

/**
 * Fetch multiple apollo references
 * @param {*} param0 { ids: string[], typename: string }
 * @param {*} param1 apollo helpers
 * @returns array of apollo references
 */
export function fetchMultiple(
  { ids, typename },
  { toReference, fieldName, cache }
) {
  return ids.map(id => {
    const cacheId = `${typename}:${id}`;
    if (cache.data.data[cacheId]) {
      return toReference({
        __typename: typename,
        id
      });
    }
    Sentry.withScope(function (scope) {
      scope.setLevel("fatal");
      scope.setContext("Apollo cache", { fieldName });
      Sentry.captureMessage(`${cacheId} is missing from cache!`);
    });
    return null;
  });
}

/**
 * Returns value from e.g nameTranslations or descriptionTranslations value
 * instead of server returned field's value
 * @param {*} value
 * @param {*} helpers apollo's reader helper methods
 * @returns translated value based on locale or default value if not found
 */
export function getTranslation(value, { readField, fieldName, cache }) {
  let locale = i18next.language;
  const translationsFieldName = `${fieldName}Translations`;
  const id = readField("id");
  const typename = readField("__typename");
  const cacheId = `${typename}:${id}`;

  let translations = [];
  if (cache.data.data[cacheId]?.[translationsFieldName]) {
    translations = cache.data.data[cacheId][translationsFieldName];
  } else translations = readField(translationsFieldName);

  let foundTranslation = translations?.find(x => x.locale == locale)?.value;
  if (!foundTranslation && locale?.includes("-")) {
    locale = locale.split("-")[0];
    foundTranslation = translations?.find(x => x.locale == locale)?.value;
  }
  return foundTranslation || value;
}
